export const INTERVIEW_STATES = {
    AWAITING: { text: "대기", value: "AWAITING" },
    PROGRESS: { text: "진행", value: "PROGRESS" },
    COMPLETE: { text: "완료", value: "COMPLETE" },
};
export const INTERVIEW_ENTRANCE_TYPES = {
    ONE_WITH_URL: { text: "링크 있는 누구나 참여가능", value: "ONE_WITH_URL" },
    INTERVIEWEES: { text: "지정된 인원만 참여가능", value: "INTERVIEWEES" },
};
export const INTERVIEW_SCHEDULE_TYPES = {
    INSTANT: { text: "즉시", value: "INSTANT" },
    ON_TIME: { text: "예약", value: "ON_TIME" },
};
